import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react"

import { TargetCartItem } from "./cart/TargetCartContext"

export enum TargetView {
  PRODUCT = "PRODUCT",
  CART = "CART",
}

type TargetState = {
  currentlySelectedProductId: string | null
  setCurrentlySelectedProductId: Dispatch<SetStateAction<string | null>>
  view: TargetView
  setView: Dispatch<SetStateAction<TargetView>>
  showImageGallery: boolean
  setShowImageGallery: Dispatch<SetStateAction<boolean>>
  addedProduct: TargetCartItem
  setAddedProduct: Dispatch<SetStateAction<TargetCartItem | null>>
}

const TargetContext = createContext<TargetState | undefined>(undefined)

const TargetProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [currentlySelectedProductId, setCurrentlySelectedProductId] =
    useState<string | null>(null)
  const [view, setView] = useState(TargetView.PRODUCT)
  const [showImageGallery, setShowImageGallery] = useState(false)
  const [addedProduct, setAddedProduct] = useState<TargetCartItem | null>(
    null,
  )

  const shopState: TargetState = {
    currentlySelectedProductId,
    setCurrentlySelectedProductId,
    view,
    setView,
    showImageGallery,
    setShowImageGallery,
    addedProduct,
    setAddedProduct,
  }

  return (
    <TargetContext.Provider value={shopState}>
      {children}
    </TargetContext.Provider>
  )
}

const useTargetContext = () => {
  const targetContext = useContext(TargetContext)
  if (!targetContext) {
    throw new Error(
      "No TargetContext.Provider found when calling useTargetContext.",
    )
  }
  return targetContext
}

export { TargetContext, TargetProvider, useTargetContext }
